import { render, staticRenderFns } from "./CategorySection.vue?vue&type=template&id=a48b5ff8&scoped=true"
import script from "./CategorySection.vue?vue&type=script&lang=ts"
export * from "./CategorySection.vue?vue&type=script&lang=ts"
import style0 from "./CategorySection.vue?vue&type=style&index=0&id=a48b5ff8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48b5ff8",
  null
  
)

export default component.exports